import { useImperativeHandle, forwardRef, useState, useRef, useContext } from 'react'
import PSAIModal from '@PSAIComponents/PSAIModal'
import styles from './index.module.scss'
import Utils from "@utils/utils"
import MattingOpt from '@view/compoents/MattingOpt/MattingOpt';
import { BATCH_IMAGES_TYPE, MATTING_OPT_TYPE } from "@utils/CONST"
import { BatchImagesContext } from '../../BatchImagesContext';


const MattingOptModal = forwardRef((props, ref) => {
    const {
        getSemanticSimTryonMaskId,
        getMultiSemanticOutput
    } = useContext(BatchImagesContext)
    const [mattingOptOpen, setMattingOptOpen] = useState(false)
    const [mattingOptType, setMattingOptType] = useState() // 保存到后端不同字段
    const [mattingOptGroups, setMattingOptGroups] = useState([])
    const [mattingOptIndex, setMattingOptIndex] = useState(0)
    const [mattingOptLoading, setMattingOptLoading] = useState(false)
    const [inputImageMultiSemanticId, setInputImageMultiSemanticId] = useState()
    const [currItem, setCurrItem] = useState()
    const mattingOptRefs = useRef([])
    const { projectType, setDataSource, dataSource } = props

    useImperativeHandle(ref, () => ({
        open: handleInitMattingOpt
    }))

    // 清理脏数据
    const resetMattingState = () => {
        setMattingOptOpen(false)
        setMattingOptGroups([])
        setMattingOptIndex(0)
        setMattingOptLoading(false)
        setInputImageMultiSemanticId()
        setCurrItem(null)
        mattingOptRefs.current = []
    }

    // 初始化数据
    const handleInitMattingOpt = async (item, type) => {
        console.log('item', item)
        setCurrItem(item)
        const inputImage = item.inputImages.filter(item => item.mainImage === true)[0]?.url
        const editedMask = item.inputImages.filter(item => item.mainImage === true)[0]?.editedMask
        console.log('editedMask', editedMask)
        setMattingOptType(type || MATTING_OPT_TYPE.REPAINT)
        let group
        if (projectType == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH) {
            let ids = ''
            // 是否曾经分割过
            if (!editedMask.inputImageMultiSemanticId) {
                const res = await getSemanticSimTryonMaskId(inputImage)
                if (!res) throw new Error('获取语义分割失败')
                ids = res.split(":")
            }

            setInputImageMultiSemanticId(ids[1])
            group = [{
                binaryMask: editedMask.repaintBinaryMask || null,
                foregroundAlphaMask: editedMask.repaintForegroundAlphaMask || null,
                foregroundMask: editedMask.repaintForegroundMask || null,
                inputImageMultiSemanticId: editedMask.inputImageMultiSemanticId || ids[1],
                inputImage: inputImage,
            }]
        }
        handleMattingOpt(0, group)
    }

    const handleMattingOpt = (current, groups) => {
        setMattingOptOpen(true)
        setMattingOptGroups(groups)
        setMattingOptIndex(current)
    }

    const handleMattingOptSave = async () => {
        setMattingOptLoading(true)
        let editedMask = {}
        for (let ref of mattingOptRefs.current) {
            const changed = await ref.saveHandle();
            if (changed) {
                const { blueMask, whiteMask, blendedImage } = changed;
                const blendedImageUrl = await Utils.uploadBase64Image(blendedImage)
                if (mattingOptType === MATTING_OPT_TYPE.REPAINT) {
                    editedMask = {
                        repaintBinaryMask: whiteMask,
                        repaintForegroundAlphaMask: blueMask,
                        repaintForegroundMask: blendedImageUrl,
                        inputImageMultiSemanticId: inputImageMultiSemanticId,
                    }
                } else if (mattingOptType === MATTING_OPT_TYPE.RETAIN) {
                    editedMask = {
                        retainBinaryMask: whiteMask,
                        retainForegroundAlphaMask: blueMask,
                        retainForegroundMask: blendedImageUrl,
                        inputImageMultiSemanticId: inputImageMultiSemanticId,
                    }
                } else if (mattingOptType === MATTING_OPT_TYPE.REFER) {
                    editedMask = {
                        referBinaryMask: whiteMask,
                        referForegroundAlphaMask: blueMask,
                        referForegroundMask: blendedImageUrl,
                        inputImageMultiSemanticId: inputImageMultiSemanticId,
                    }
                }
                console.log('editedMask ', editedMask)
            } else {
                console.log('no change')
                editedMask = {}
            }
        }
        // 将editedMask更新到dataSource中对应skuId项的inputImages中mainImage为true的项里
        setDataSource(prevDataSource => {
            return prevDataSource.map(item => {
                if (item.skuId === currItem.skuId) {
                    const updatedInputImages = [...item.inputImages];

                    const mainImageIndex = updatedInputImages.findIndex(img => img.mainImage === true);
                    if (mainImageIndex !== -1) {
                        updatedInputImages[mainImageIndex] = {
                            ...updatedInputImages[mainImageIndex],
                            editedMask: editedMask
                        };
                    }

                    return {
                        ...item,
                        inputImages: updatedInputImages
                    };
                }
                return item;
            });
        });


        setMattingOptLoading(false)
        setMattingOptOpen(false)
        resetMattingState()
    }


    return (
        <PSAIModal
            title='编辑保留区域'
            maxWidth={1300}
            closable={false}
            maskClosable={false}
            open={mattingOptOpen}
            confirmLoading={mattingOptLoading}
            okText="保存修改"
            cancelText="放弃修改"
            onCancel={() => resetMattingState()}
            onOk={handleMattingOptSave}
        >
            <div className={`${styles.MattingOptList} ${mattingOptGroups.length > 1 ? styles.MattingOptListMulti : ""}`}>
                {
                    mattingOptGroups.length > 1 &&
                    <div className={styles.MattingOptListLeft}>
                        {
                            mattingOptGroups.map((item, index) => (
                                <div
                                    key={item.inputImage}
                                    className={`${styles.MattingOptListLeftItem} ${index == mattingOptIndex ? styles.actived : ""}`}
                                    onClick={() => setMattingOptIndex(index)}
                                >
                                    <img src={item.inputImage} alt="" />
                                </div>
                            ))
                        }
                    </div>
                } {
                    mattingOptGroups.map((item, index) => (
                        <div key={`${item.inputImage}-${index}`} style={{ display: index == mattingOptIndex ? "block" : "none" }}>
                            <MattingOpt
                                ref={ref => mattingOptRefs.current[index] = ref}
                                imageType={projectType} // 仅用于埋点
                                aiInteractiveNpyId={item.interactiveNpyId}
                                blueMask={item.foregroundAlphaMask}
                                whiteMask={item.binaryMask}
                                inputImage={item.inputImage}
                                inputImageMultiSemanticId={item.inputImageMultiSemanticId}
                                getMultiSemanticOutput={getMultiSemanticOutput}
                            />
                        </div>
                    ))
                }
            </div>
        </PSAIModal>
    )



})

export default MattingOptModal